import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ErrorsState {
  nameError?: string;
  phoneError?: string;
  emailError?: string;
  paymentError?: string;
  takeoutError?: string;
  deliveryError?: string;
  orderPointError?: string;
  fulfillmentToTimeError?: string;
  documentsAgreementsError?: boolean;
}

const initialState: ErrorsState = {};

export const errorsSlice = createSlice({
  name: 'errors',
  initialState,

  reducers: {
    setNameError(state, { payload }: PayloadAction<string | undefined>) {
      state.nameError = payload;
    },
    setPhoneError(state, { payload }: PayloadAction<string | undefined>) {
      state.phoneError = payload;
    },
    setEmailError(state, { payload }: PayloadAction<string | undefined>) {
      state.emailError = payload;
    },
    setPaymentError(state, { payload }: PayloadAction<string | undefined>) {
      state.paymentError = payload;
    },
    setTakeoutError(state, { payload }: PayloadAction<string | undefined>) {
      state.takeoutError = payload;
    },
    setDeliveryError(state, { payload }: PayloadAction<string | undefined>) {
      state.deliveryError = payload;
    },
    setOrderPointError(state, { payload }: PayloadAction<string | undefined>) {
      state.orderPointError = payload;
    },
    setFulfillmentToTimeError(state, { payload }: PayloadAction<string | undefined>) {
      state.fulfillmentToTimeError = payload;
    },
    setDocumentsAgreementsError(state, { payload }: PayloadAction<boolean>) {
      state.documentsAgreementsError = payload;
    },

    clearErrors(state) {
      state.takeoutError = undefined;
      state.deliveryError = undefined;
      state.orderPointError = undefined;
    },
  },
});

export const {
  clearErrors,
  setNameError,
  setPhoneError,
  setEmailError,
  setPaymentError,
  setTakeoutError,
  setDeliveryError,
  setOrderPointError,
  setFulfillmentToTimeError,
  setDocumentsAgreementsError,
} = errorsSlice.actions;

export const errorsReducer = errorsSlice.reducer;
